import { Alert, Button } from '@mui/material';
import VisibilityRounded from '@mui/icons-material/VisibilityRounded';
import { stopViewAs } from './viewAs';
import type { Me } from './types';

/** On top of every page while an admin or coordinator sees Lousa as someone else. */
export function ViewAsBanner({ me }: { me: Me }) {
  if (!me.viewer) return null;
  return (
    <Alert
      severity="warning"
      icon={<VisibilityRounded fontSize="inherit" />}
      square
      sx={{ alignItems: 'center', '& .MuiAlert-message': { flex: 1 } }}
      action={
        <Button color="inherit" size="small" onClick={stopViewAs} sx={{ whiteSpace: 'nowrap' }}>
          Voltar para a minha conta
        </Button>
      }
    >
      Você está vendo o Lousa como <strong>{me.user.name || me.user.email}</strong>, só para
      leitura: nada que você fizer aqui muda os dados dessa pessoa.
    </Alert>
  );
}
